export const truncateString = (string, length) => `${(string || '').substring(0,length)}...`
